import { useContext } from 'react';
import { format } from '../../../../../helpers/formatter';
import { useInfoSync } from '../../../../../Hooks/useInfoSync';
import { Articulo } from '../../../../Productos/Articulo';
import { ButtonsActionsCart } from '../../ButtonsActionsCart/ButtonsActionsCart';
import { UserContext } from '../../../../auth/context/UserContext';

import '../radius.css';

export const ProductRow = ({
  articulo,
  stockUnitario,
  showActions,
  precios,
  priceToDisplay,
  dataClient,
}) => {
  const { sinonimo, codigo_mg, descripcion_2 } = articulo;

  const { data: dataInfoSync } = useInfoSync();
  const monedaData = dataInfoSync?.moneda_carrito || 0;

  const { dataUser } = useContext(UserContext);
  const userData = dataUser;

  const visualizaStock = userData.visualizaStock;

  return (
    <tr className="renglon-posicion">
      <td className="tabla__contenido codigo">{codigo_mg}</td>
      <td className="tabla__contenido codigo_sin" title={sinonimo}>
        {sinonimo}
      </td>
      <td className="tabla__contenido tabla__denom descripcion">
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Articulo articulo={articulo} />
          <small style={{ textAlign: 'left', fontSize: '12px' }}>
            {descripcion_2}
          </small>
        </div>
      </td>
      {visualizaStock ? (<td
        className="tabla__contenido tabla__num stocks"
      >
        {stockUnitario}
      </td>) : (<td></td>)}
      <td
        className={
          !dataClient
            ? 'tabla__titulo tabla__precio precio tabla__num'
            : 'tabla__titulo tabla__precio precios tabla__num'
        }
      >
        {format.currency(/*monedaData*/ articulo.moneda, priceToDisplay) || 0}
      </td>
      {showActions && (
        <td className="cell-actions-table precio">
          <ButtonsActionsCart
            articulo={articulo}
            precios={precios}
            moneda={monedaData}
          />
        </td>
      )}
    </tr>
  );
};
